import { Building20Regular } from '@fluentui/react-icons';

import { UserSessionWidgetComponent } from '../User/UserSessionWidgetComponent';
import { useCurrentTenant } from './useCurrentTenant';

export const TopBarComponent = () => {
  const tenant = useCurrentTenant();

  return (
    <div className="topBar">
      {/* El logo se mudo del menu lateral al header: ahi ocupaba 180px de alto
          fijo en una barra que ahora se contrae, y esa altura no se podia
          recuperar para los items. */}
      <img
        className="topBarLogo"
        src={require('../../assets/img/logo_alphacr.png')}
        alt="Ichtys"
      />
      <div className="topBarRight">
        {/* El centro con el que se esta operando, junto a la cuenta. Va del lado
            derecho y no al lado del logo: ahi el fondo es un degrade azul que se
            funde a blanco, y un texto encima perderia contraste a mitad de camino. */}
        {tenant && (
          <span className="topBarTenant" title={tenant.tenantName}>
            <Building20Regular className="topBarTenantIcon" />
            <span className="topBarTenantName">{tenant.tenantName}</span>
          </span>
        )}
        <UserSessionWidgetComponent />
      </div>
    </div>
  );
};
